import React from 'react';
import './Contact.css';

const Contact = () => {
  const contactInfo = [
    {
      icon: '📧',
      title: 'Email',
                content: 'support@ludiclabstech.com',
      link: 'mailto:support@ludiclabstech.com'
    },
    {
      icon: '📍',
      title: 'Address',
      content: 'RM A5,7/F, ASTORIA BUILDING, NO.34 ASHLEY ROAD, TSIM SHA TSUI HONG KONG',
      link: '#'
    },
    {
      icon: '🌐',
      title: 'Business Hours',
      content: 'Mon - Fri: 9:00 AM - 6:00 PM (UTC+8)',
      link: '#'
    }
  ];

  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="contact-header">
          <h2 className="section-title">Contact Us</h2>
          <p className="section-subtitle">
            Get in touch with Ludic Labs Technology Limited 
            for partnership opportunities, business inquiries, or learn more about our game development services.
          </p>
        </div>

        <div className="contact-content">
          <div className="contact-info-grid">
            {contactInfo.map((item, index) => (
              <div key={index} className="contact-card">
                <div className="contact-icon">{item.icon}</div>
                <div className="contact-details">
                  <h4>{item.title}</h4>
                  {item.link === '#' ? (
                    <p>{item.content}</p>
                  ) : (
                    <a href={item.link}>{item.content}</a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
